/*
 * Action types
 */

const NS = 'breakpoints'; // Namespace

export const ADD = `${NS}/ADD`;
export const REMOVE = `${NS}/REMOVE`;
